var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full relative"},[(_vm.goodsList && _vm.goodsList.length > 0)?_c(_vm.currentComponent,{tag:"component",attrs:{"teacher_id":"teacher_id","goodsList":_vm.goodsList},on:{"imgClick":_vm.imgClick,"buyClick":_vm.buyClick}}):_c('div',[_c('van-empty',{attrs:{"description":"没有数据"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }